const initialState = {
  listTraining: [],
  listPembinaan: [],
  kpi1: null,
  kpi2: null,
  calendar: [],
  listAbsensi: [],
  kpi3: null,
  absensiDashboard: null,
  allEvent: null,
  allEventCalendar: null,
  jmlKaryawan: [],
  belumAbsen: [],
  listAbsenManual: [],
  listKategoriAbsen: [],
};

const trainingReducer = (state = initialState, action) => {
  let { type, data } = action;

  switch (type) {
    case "SET_ALLEVENT":
      return {
        ...state,
        allEvent: data,
      };
    case "SET_LISTTRAINING":
      return {
        ...state,
        listTraining: data,
      };
    case "SET_KPI1TRAINING":
      return {
        ...state,
        kpi1: data,
      };
    case "SET_LISTPEMBINAAN":
      return {
        ...state,
        listPembinaan: data,
      };
    case "SET_KPI2PEMBINAAN":
      return {
        ...state,
        kpi2: data,
      };
    case "SET_CALENDAR":
      return {
        ...state,
        calendar: data,
      };
    case "SET_LISTABSENSI":
      return {
        ...state,
        listAbsensi: data,
      };
    case "SET_KPI3ABSENSI":
      return {
        ...state,
        kpi3: data,
      };
    case "SET_KPIABSENSIDASHBOARD":
      return {
        ...state,
        absensiDashboard: data,
      };
    case "SET_ALLEVENTCALENDAR":
      return {
        ...state,
        allEventCalendar: data,
      };
    case "SET_JMLKARYAWAN":
      return {
        ...state,
        jmlKaryawan: data,
      };
    case "SET_BELUMABSEN":
      return {
        ...state,
        belumAbsen: data,
      };
    case "SET_LISTABSENSIMANUAL":
      return {
        ...state,
        listAbsenManual: data,
      };
    case "SET_LIST_KATEGORI_ABSEN":
      return {
        ...state,
        listKategoriAbsen: data,
      };
    default:
      return state;
  }
};

export default trainingReducer;
